const { axios, API_URL, generateHeaders } = require('./helper');

/************* Pure Proxy *************/
const get = async (path, params) => {
    const response = await axios.get(`${API_URL}${path}`, {
        headers: generateHeaders(),
        params: params
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const put = async (body, path) => {
    const response = await axios.put(`${API_URL}${path}`, body, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const post = async (body, path) => {
    const response = await axios.post(`${API_URL}${path}`, body, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

module.exports = {
    get,
    put,
    post
}